
import BaseHttpClient from '@/core/HttpResources/BaseHttpClient';
import DocumentModel from '@/models/document.model';
import Axios from "axios";
import BaseApi from '@/core/HttpResources/BaseApi';

class FileService {
    private client: BaseHttpClient;
    constructor(public controller: string = 'files') {
        this.client = new BaseHttpClient(controller);
    }

    public async uploadMany(files: File[], action = 'upload-many'): Promise<DocumentModel[]> {
        try {
            var data = new FormData();
            files.forEach((x) => data.append('files', x));
            var result = await this.client.postAsync<DocumentModel[]>(action, data);
            return result;
        } catch (error) {
            throw error;
        }
    }
    public async upload(file: File, action = 'upload'): Promise<DocumentModel> {
        try {
            var data = new FormData();
            data.append('file', file);
            var result = await this.client.postAsync<DocumentModel>(action, data);
            return result;
        } catch (error) {
            throw error;
        }
    }

    public download(documentId: number, action = 'download', blank = true) {
        try {
            var target = blank ? '_blank' : undefined;
                window.open(`${process.env.VUE_APP_API_URL}files/${action}?documentId=${documentId}`, target);
            //var result = await this.client.getAsync<File>(action, { documentoId: documentoId});
        } catch (error) {
            throw error;
        }
    }

    public downloadOctetFile(documentId: number, fileName: string) {
        Axios({
            url: `${process.env.VUE_APP_BASE_API_URL}api/Files/downloadOctetFiles?documentId=${documentId}`,
            method: 'GET',
            responseType: 'blob',
            }).then((response) => {
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', fileName);
              document.body.appendChild(fileLink);
              fileLink.click();
         });
    }

    async getDocumentById(id: number) {
        var baseApi = new BaseApi("Documents/" + id);
        return new Promise<any>((resolve, reject) =>
          baseApi.request(
            "GET",
            String(),
            null,
            {},
            response => resolve(response.data),
            reject,
            () => {}
          )
        );
      }
}

export default new FileService();